// Add your custom JS here.

/**
 * Submits a lead form (Availability panel / floorplan modal - Inquire Now
 * has its own server-rendered POST flow, not this) to the Parkfield Leads
 * plugin via AJAX rather than a normal page POST, so the open panel/modal
 * state isn't lost on reload. On success, navigates to the Thank You page
 * (same destination Inquire Now's own POST flow redirects to); on failure,
 * shows the error in messageEl and leaves the form up so the visitor can
 * retry without losing the open panel/modal.
 *
 * @param {HTMLFormElement} form      The form being submitted.
 * @param {string}          source    'availability_panel' or 'floorplan_modal'.
 * @param {HTMLElement}     messageEl Element to show the error message in.
 */
function parkfieldSubmitLead(form, source, messageEl) {
    if (!window.parkfieldLeads || !window.parkfieldGetRecaptchaToken) {
        if (messageEl) {
            messageEl.textContent =
                (window.parkfieldRecaptcha &&
                    window.parkfieldRecaptcha.error) ||
                'Security check unavailable. Please try again.';
            messageEl.hidden = false;
            messageEl.classList.add('is-error');
        }
        return;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
        submitBtn.disabled = true;
    }

    function showMessage(text, isError) {
        if (!messageEl) {
            return;
        }

        messageEl.textContent = text;
        messageEl.hidden = false;
        messageEl.classList.toggle('is-error', !!isError);
        messageEl.classList.toggle('is-success', !isError);
    }

    window
        .parkfieldGetRecaptchaToken()
        .then(function (token) {
            var formData = new FormData(form);
            formData.append('action', 'parkfield_submit_lead');
            formData.append('nonce', window.parkfieldLeads.nonce);
            formData.append('source', source);
            formData.append('page_url', window.location.href);
            formData.append('g-recaptcha-response', token);

            return fetch(window.parkfieldLeads.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            });
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (result) {
            if (result && result.success) {
                window.location.href = window.parkfieldLeads.thankYouUrl;
            } else {
                if (submitBtn) {
                    submitBtn.disabled = false;
                }

                showMessage(
                    (result && result.data && result.data.message) ||
                        'There was a problem submitting your request. Please try again.',
                    true
                );
            }
        })
        .catch(function () {
            if (submitBtn) {
                submitBtn.disabled = false;
            }

            showMessage(
                'There was a problem submitting your request. Please try again.',
                true
            );
        });
}

document.addEventListener('DOMContentLoaded', function () {
    var aboutPage = document.querySelector('.about-page');

    if (!aboutPage) {
        return;
    }

    // Services accordion.
    aboutPage.querySelectorAll('.service-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            var item = toggle.closest('.service-item');
            var isOpen = item.classList.contains('is-open');
            var icon = toggle.querySelector('.service-toggle__icon');

            item.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', String(!isOpen));
            if (icon) {
                icon.textContent = isOpen ? '+' : '−';
            }
        });
    });

    // Hero sound toggle.
    var soundToggle = aboutPage.querySelector('.about-hero__sound-toggle');
    var heroVideo = aboutPage.querySelector('.about-hero__media');

    if (soundToggle && heroVideo) {
        soundToggle.addEventListener('click', function () {
            heroVideo.muted = !heroVideo.muted;
            soundToggle.querySelector('span').textContent = heroVideo.muted
                ? 'Play Sound'
                : 'Mute Sound';
        });
    }

    // Culture gallery, powered by Slick (loaded separately as a classic
    // script so its jQuery plugin attaches to the global jQuery instance).
    var galleryTrack = aboutPage.querySelector('.about-gallery__track');

    if (galleryTrack && window.jQuery && window.jQuery.fn.slick) {
        var $ = window.jQuery;
        var $track = $(galleryTrack);

        $track.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            speed: 400
        });

        $(
            aboutPage.querySelector(
                '.about-gallery__nav [data-direction="prev"]'
            )
        ).on('click', function () {
            $track.slick('slickPrev');
        });

        $(
            aboutPage.querySelector(
                '.about-gallery__nav [data-direction="next"]'
            )
        ).on('click', function () {
            $track.slick('slickNext');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var galleryPage = document.querySelector('.gallery-page');

    if (!galleryPage) {
        return;
    }

    // Filter tabs + "See more" reveal for the masonry grid. Everything needed
    // is already in the DOM (rendered server-side from the "gallery" CPT), so
    // filtering just toggles visibility rather than re-fetching anything.
    var items = Array.prototype.slice.call(
        galleryPage.querySelectorAll('.gallery-item')
    );
    var filterButtons = Array.prototype.slice.call(
        galleryPage.querySelectorAll('.gallery-filter')
    );
    var seeMoreBtn = galleryPage.querySelector('.gallery-see-more');
    var initialCount = 9;
    var currentFilter = 'all';
    var expanded = false;

    // Matches the opacity/transform transition duration on .gallery-item in
    // _gallery-page.scss - fades an item out before actually removing it from
    // the column flow (display:none), and fades a newly-shown item back in.
    var FADE_MS = 300;

    function setGalleryItemVisible(item, visible) {
        if (item.galleryHideTimeout) {
            window.clearTimeout(item.galleryHideTimeout);
            item.galleryHideTimeout = null;
        }

        if (visible) {
            var wasHidden = item.classList.contains('is-hidden');

            item.classList.remove('is-hidden');

            if (wasHidden) {
                item.classList.add('is-fading');
                void item.offsetWidth; // Force a reflow so the fade-in transition actually plays.
            }

            item.classList.remove('is-fading');
        } else if (!item.classList.contains('is-hidden')) {
            item.classList.add('is-fading');

            item.galleryHideTimeout = window.setTimeout(function () {
                item.classList.add('is-hidden');
                item.classList.remove('is-fading');
                item.galleryHideTimeout = null;
            }, FADE_MS);
        }
    }

    function applyGalleryVisibility(animate) {
        var shown = 0;

        items.forEach(function (item) {
            var matchesFilter =
                'all' === currentFilter ||
                item.dataset.filter === currentFilter;
            var withinInitialCount = expanded || shown < initialCount;
            var visible = matchesFilter && withinInitialCount;

            if (animate) {
                setGalleryItemVisible(item, visible);
            } else {
                item.classList.toggle('is-hidden', !visible);
            }

            if (matchesFilter) {
                shown++;
            }
        });

        if (seeMoreBtn) {
            seeMoreBtn.style.display =
                !expanded && shown > initialCount ? 'flex' : 'none';
        }
    }

    filterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            currentFilter = button.dataset.filter;
            expanded = false;

            filterButtons.forEach(function (otherButton) {
                otherButton.classList.toggle(
                    'is-active',
                    otherButton === button
                );
            });

            applyGalleryVisibility(true);
        });
    });

    if (seeMoreBtn) {
        seeMoreBtn.addEventListener('click', function () {
            expanded = true;
            applyGalleryVisibility(true);
        });
    }

    applyGalleryVisibility(false);

    // Lightbox. Clicking any image opens it full-size; prev/next cycle through
    // whatever matches the *active filter* (not just what's currently on
    // screen), so browsing isn't limited by the "See more" cap.
    var lightbox = galleryPage.querySelector('.gallery-lightbox');

    if (lightbox) {
        var lightboxImage = lightbox.querySelector('.gallery-lightbox__image');
        var lightboxCaption = lightbox.querySelector(
            '.gallery-lightbox__caption'
        );
        var lightboxClose = lightbox.querySelector('.gallery-lightbox__close');
        var lightboxPrev = lightbox.querySelector('.gallery-lightbox__prev');
        var lightboxNext = lightbox.querySelector('.gallery-lightbox__next');
        var lightboxIndex = -1;
        var lastFocusedTrigger = null;

        var getFilteredTriggers = function () {
            return items
                .filter(function (item) {
                    return (
                        'all' === currentFilter ||
                        item.dataset.filter === currentFilter
                    );
                })
                .map(function (item) {
                    return item.querySelector('.gallery-item__trigger');
                })
                .filter(Boolean);
        };

        var showLightboxAt = function (index) {
            var triggers = getFilteredTriggers();

            if (!triggers.length) {
                return;
            }

            lightboxIndex = (index + triggers.length) % triggers.length;

            var trigger = triggers[lightboxIndex];
            lightboxImage.src = trigger.dataset.full;
            lightboxImage.alt = trigger.dataset.alt || '';
            lightboxCaption.textContent = trigger.dataset.caption || '';
        };

        var openLightbox = function (trigger) {
            lastFocusedTrigger = trigger;
            showLightboxAt(getFilteredTriggers().indexOf(trigger));
            lightbox.hidden = false;
            document.body.classList.add('gallery-lightbox-open');
            lightboxClose.focus();
        };

        var closeLightbox = function () {
            lightbox.hidden = true;
            lightboxImage.src = '';
            lightboxCaption.textContent = '';
            document.body.classList.remove('gallery-lightbox-open');

            if (lastFocusedTrigger) {
                lastFocusedTrigger.focus();
            }
        };

        galleryPage
            .querySelectorAll('.gallery-item__trigger')
            .forEach(function (trigger) {
                trigger.addEventListener('click', function () {
                    openLightbox(trigger);
                });
            });

        lightboxClose.addEventListener('click', closeLightbox);
        lightboxPrev.addEventListener('click', function () {
            showLightboxAt(lightboxIndex - 1);
        });
        lightboxNext.addEventListener('click', function () {
            showLightboxAt(lightboxIndex + 1);
        });

        // Click on the dark backdrop (not the image or the buttons) closes it too.
        lightbox.addEventListener('click', function (event) {
            if (event.target === lightbox) {
                closeLightbox();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (lightbox.hidden) {
                return;
            }

            if ('Escape' === event.key) {
                closeLightbox();
            } else if ('ArrowLeft' === event.key) {
                showLightboxAt(lightboxIndex - 1);
            } else if ('ArrowRight' === event.key) {
                showLightboxAt(lightboxIndex + 1);
            }
        });
    }

    // Video slider (Slick) with a custom play/pause button per slide, driven
    // by the Vimeo Player API. Only one video is ever meant to be playing:
    // changing slides pauses the one being left, and scrolling the slider
    // out of view pauses whichever is still playing too.
    var videoSlider = galleryPage.querySelector('.video-slick-slider');
    var videoTrack = videoSlider
        ? videoSlider.querySelector('.video-slick-slider__track')
        : null;

    if (videoTrack && window.jQuery && window.jQuery.fn.slick && window.Vimeo) {
        var $videoTrack = window.jQuery(videoTrack);

        var videoPlayers = Array.prototype.slice
            .call(videoTrack.querySelectorAll('.video-slick-slider__slide'))
            .map(function (slide) {
                var toggle = slide.querySelector('.video-slick-slider__toggle');
                var player = new window.Vimeo.Player(
                    slide.querySelector('iframe')
                );

                player.on('play', function () {
                    slide.classList.add('is-playing');
                    toggle.classList.add('is-playing');
                    toggle.setAttribute('aria-label', 'Pause video');
                });

                player.on('pause', function () {
                    slide.classList.remove('is-playing');
                    toggle.classList.remove('is-playing');
                    toggle.setAttribute('aria-label', 'Play video');
                });

                toggle.addEventListener('click', function () {
                    if (toggle.classList.contains('is-playing')) {
                        player.pause();
                    } else {
                        player.play();
                    }
                });

                return player;
            });

        var pauseAllVideos = function () {
            videoPlayers.forEach(function (player) {
                player.pause();
            });
        };

        $videoTrack.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            speed: 400
        });

        // Slide changes (from the dots or a swipe/drag) pause whatever was
        // playing on the slide being left.
        $videoTrack.on('beforeChange', pauseAllVideos);

        // Scrolling the slider out of view pauses whatever is still playing.
        if (window.IntersectionObserver) {
            var videoSliderObserver = new IntersectionObserver(function (
                entries
            ) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) {
                        pauseAllVideos();
                    }
                });
            });

            videoSliderObserver.observe(videoSlider);
        }
    }
});

// Shared Google Maps callback for every page that embeds a map (Community's
// category map, Contact's office map). Registered as a global because the
// Maps API script itself calls it directly once loaded (see the ?callback=
// param in functions.php) - it isn't wrapped in a DOMContentLoaded block, but
// functions.php only ever enqueues the Maps script alongside child-theme.js,
// and after it in the dependency graph, so any map container is guaranteed to
// already exist in the DOM by the time this runs.
window.parkfieldInitGoogleMaps = function () {
    parkfieldInitCommunityMap();
    parkfieldInitContactMap();
};

function parkfieldInitCommunityMap() {
    var mapEl = document.getElementById('community-map');

    if (!mapEl || !window.google || !window.google.maps) {
        return;
    }

    var categories;

    try {
        categories = JSON.parse(mapEl.dataset.categories || '[]');
    } catch (error) {
        categories = [];
    }

    var DEFAULT_PIN_COLOR = '#3e93a1';
    var HOVER_PIN_COLOR = '#f2633c';

    // Centred on the real Parkfield Towns / Daniels MPV site itself (the
    // "Daniels - MPV" pin from the client's "MPV Area Amenity Map.kmz"),
    // not the Mount Pleasant Village placeholder this used before real
    // category data existed. fitBounds() re-centers per category anyway,
    // so this is only what's visible before a category is opened/loaded.
    var map = new google.maps.Map(mapEl, {
        center: { lat: 43.6728332, lng: -79.8249112 },
        zoom: 13
    });

    var markers = [];

    function pinIcon(color) {
        return {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 10
        };
    }

    // The Parkfield Towns / Daniels MPV site itself ("Daniels - MPV" in the
    // client's KMZ) - shown permanently, on top of whichever category is
    // active, rather than being cleared/replaced by renderCategory() like
    // the category markers below.
    var siteMarker = new google.maps.Marker({
        position: { lat: 43.6728332, lng: -79.8249112 },
        map: map,
        title: 'Parkfield Towns',
        icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: '#92c55c',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 12
        },
        zIndex: 999
    });

    function renderCategory(slug) {
        markers.forEach(function (marker) {
            marker.setMap(null);
        });
        markers = [];

        var category = categories.filter(function (candidate) {
            return candidate.slug === slug;
        })[0];

        if (!category) {
            return;
        }

        var bounds = new google.maps.LatLngBounds();
        bounds.extend(siteMarker.getPosition());

        category.places.forEach(function (place) {
            var marker = new google.maps.Marker({
                position: { lat: place.lat, lng: place.lng },
                map: map,
                title: place.name,
                icon: pinIcon(DEFAULT_PIN_COLOR)
            });

            markers.push(marker);
            bounds.extend(marker.getPosition());
        });

        if (!bounds.isEmpty()) {
            map.fitBounds(bounds);
        }
    }

    // Exposed so the accordion click/hover handlers (in the DOMContentLoaded
    // block below) can drive the map without this callback needing to know
    // anything about the accordion markup.
    window.parkfieldCommunityMap = {
        renderCategory: renderCategory,
        highlightMarker: function (index, isHighlighted) {
            var marker = markers[index];

            if (marker) {
                marker.setIcon(
                    pinIcon(isHighlighted ? HOVER_PIN_COLOR : DEFAULT_PIN_COLOR)
                );
            }
        }
    };

    var openItem = document.querySelector('.community-accordion__item.is-open');

    if (openItem) {
        renderCategory(openItem.dataset.category);
    }
}

function parkfieldInitContactMap() {
    var mapEl = document.getElementById('contact-map');

    if (!mapEl || !window.google || !window.google.maps) {
        return;
    }

    var lat = parseFloat(mapEl.dataset.lat);
    var lng = parseFloat(mapEl.dataset.lng);
    var position = { lat: lat, lng: lng };

    var map = new google.maps.Map(mapEl, {
        center: position,
        zoom: 15
    });

    new google.maps.Marker({
        position: position,
        map: map,
        title: mapEl.dataset.title || ''
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var communityPage = document.querySelector('.community-page');

    if (!communityPage) {
        return;
    }

    // "Everything within easy reach" carousel, powered by Slick (see the
    // about-page gallery block above for why it's loaded as a classic script).
    var easyReachTrack = communityPage.querySelector(
        '.community-easy-reach__track'
    );

    if (easyReachTrack && window.jQuery && window.jQuery.fn.slick) {
        window.jQuery(easyReachTrack).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            arrows: true,
            dots: true,
            prevArrow: communityPage.querySelector(
                '.community-easy-reach__arrow--prev'
            ),
            nextArrow: communityPage.querySelector(
                '.community-easy-reach__arrow--next'
            ),
            responsive: [
                {
                    breakpoint: 992,
                    settings: { slidesToShow: 2, slidesToScroll: 2 }
                },
                {
                    breakpoint: 576,
                    settings: { slidesToShow: 1, slidesToScroll: 1 }
                }
            ]
        });
    }

    // Category accordion (single item open at a time) + map sync. Clicking a
    // category swaps the map's pins to that category (via
    // window.parkfieldCommunityMap, set up by parkfieldInitCommunityMap
    // above); hovering a place name in the open category highlights its pin.
    var accordionItems = Array.prototype.slice.call(
        communityPage.querySelectorAll('.community-accordion__item')
    );

    accordionItems.forEach(function (item) {
        var toggle = item.querySelector('.community-accordion__toggle');
        var icon = item.querySelector('.community-accordion__icon');

        toggle.addEventListener('click', function () {
            var alreadyOpen = item.classList.contains('is-open');

            accordionItems.forEach(function (otherItem) {
                var otherIcon = otherItem.querySelector(
                    '.community-accordion__icon'
                );

                otherItem.classList.remove('is-open');
                otherItem
                    .querySelector('.community-accordion__toggle')
                    .setAttribute('aria-expanded', 'false');

                if (otherIcon) {
                    otherIcon.textContent = '+';
                }
            });

            if (alreadyOpen) {
                return;
            }

            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');

            if (icon) {
                icon.textContent = '−';
            }

            if (window.parkfieldCommunityMap) {
                window.parkfieldCommunityMap.renderCategory(
                    item.dataset.category
                );
            }
        });

        item.querySelectorAll('.community-accordion__place').forEach(
            function (place) {
                var setHighlight = function (isHighlighted) {
                    if (
                        item.classList.contains('is-open') &&
                        window.parkfieldCommunityMap
                    ) {
                        window.parkfieldCommunityMap.highlightMarker(
                            Number(place.dataset.index),
                            isHighlighted
                        );
                    }
                };

                place.addEventListener('mouseenter', function () {
                    setHighlight(true);
                });
                place.addEventListener('mouseleave', function () {
                    setHighlight(false);
                });
            }
        );
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var aboutDanielsPage = document.querySelector('.about-daniels-page');

    if (!aboutDanielsPage) {
        return;
    }

    // Feature image slider(s), powered by Slick: the image slides with
    // Slick's own transition, while the caption title crossfades on its own
    // (faded out just before the slide change, swapped and faded back in
    // once it completes) instead of sliding with the image.
    aboutDanielsPage
        .querySelectorAll('.about-daniels-slider')
        .forEach(function (slider) {
            var track = slider.querySelector('.about-daniels-slider__track');

            if (!track || !window.jQuery || !window.jQuery.fn.slick) {
                return;
            }

            var $ = window.jQuery;
            var $track = $(track);
            var $title = $(
                slider.querySelector('.about-daniels-slider__title')
            );
            var slides = track.querySelectorAll('.about-daniels-slider__slide');

            $track.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                fade: false
            });

            $track.on('beforeChange', function () {
                $title.css('opacity', 0);
            });

            $track.on('afterChange', function (event, slick, currentSlide) {
                var slide = slides[currentSlide];
                $title.text(slide ? slide.dataset.title : '');
                $title.css('opacity', 1);
            });

            $(slider.querySelector('.about-daniels-slider__arrow--prev')).on(
                'click',
                function () {
                    $track.slick('slickPrev');
                }
            );

            $(slider.querySelector('.about-daniels-slider__arrow--next')).on(
                'click',
                function () {
                    $track.slick('slickNext');
                }
            );
        });
});

document.addEventListener('DOMContentLoaded', function () {
    var availabilityPage = document.querySelector('.availability-page');

    if (!availabilityPage) {
        return;
    }

    // Floorplan View / Site Plan View switch - shows the matching
    // [data-view-panel] and marks the clicked button active, in place of
    // the Gallery page's category filtering.
    var toggleButtons = Array.prototype.slice.call(
        availabilityPage.querySelectorAll('.availability-view-toggle__btn')
    );
    var panels = Array.prototype.slice.call(
        availabilityPage.querySelectorAll('[data-view-panel]')
    );

    function activateView(view) {
        var matched = toggleButtons.some(function (button) {
            return button.dataset.view === view;
        });

        if (!matched) {
            return;
        }

        toggleButtons.forEach(function (button) {
            button.classList.toggle('is-active', button.dataset.view === view);
        });

        panels.forEach(function (panel) {
            panel.hidden = panel.dataset.viewPanel !== view;
        });
    }

    toggleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            activateView(button.dataset.view);
        });
    });

    // Deep link from a floorplan's own page ("View on Siteplan") - e.g.
    // /availablity/?view=siteplan - opens straight to that view instead of
    // the default Floorplan View.
    var requestedView = new URLSearchParams(window.location.search).get('view');

    if (requestedView) {
        activateView(requestedView);
    }

    // Site plan: clicking a colored slot polygon fills in the detail panel
    // and expands the (initially zero-width) panel grid column - see
    // .availability-siteplan__inner in _availability-page.scss.
    var siteplanSlots = Array.prototype.slice.call(
        availabilityPage.querySelectorAll('.availability-siteplan__slot')
    );
    var siteplanInner = availabilityPage.querySelector(
        '.availability-siteplan__inner'
    );
    var panelClose = availabilityPage.querySelector(
        '.availability-siteplan__panel-close'
    );
    var panelBand = availabilityPage.querySelector(
        '#availability-siteplan-panel-band'
    );
    var panelName = availabilityPage.querySelector(
        '#availability-siteplan-panel-name'
    );
    var panelUnit = availabilityPage.querySelector(
        '#availability-siteplan-panel-unit'
    );
    var panelDetails = availabilityPage.querySelector(
        '#availability-siteplan-panel-details'
    );
    var panelPrice = availabilityPage.querySelector(
        '#availability-siteplan-panel-price'
    );
    var panelPdf = availabilityPage.querySelector(
        '#availability-siteplan-panel-pdf'
    );
    var panelCarbon = availabilityPage.querySelector(
        '#availability-siteplan-panel-carbon'
    );
    var panelCarbonImg = availabilityPage.querySelector(
        '#availability-siteplan-panel-carbon-img'
    );
    var panelInquireBtn = availabilityPage.querySelector(
        '#availability-siteplan-panel-inquire-btn'
    );
    var panelViews = availabilityPage.querySelector(
        '#availability-siteplan-panel-views'
    );
    var inquiryBackBtn = availabilityPage.querySelector(
        '#availability-siteplan-panel-back'
    );
    var inquiryName = availabilityPage.querySelector(
        '#availability-siteplan-inquiry-name'
    );
    var inquirySummary = availabilityPage.querySelector(
        '#availability-siteplan-inquiry-summary'
    );
    var inquiryFloorplanField = availabilityPage.querySelector(
        '#availability-siteplan-inquiry-floorplan-field'
    );
    var inquiryUnitField = availabilityPage.querySelector(
        '#availability-siteplan-inquiry-unit-field'
    );
    var activeSlot = null;

    // Slot price is stored as a bare number (e.g. "2000"), not "$2,000 /
    // month", so it can be compared/sorted numerically elsewhere - this is
    // just how it's displayed here.
    function formatSlotPrice(price) {
        var num = parseInt(price, 10);
        if (!price || isNaN(num)) {
            return '';
        }
        return '$' + num.toLocaleString('en-US') + ' / month';
    }

    // The "Inquire Now" button inside the detail sub-view slides in a
    // second sub-view (the inline inquiry form) within the same panel,
    // rather than navigating to the Inquire Now page - see
    // .availability-siteplan__panel-views in _availability-page.scss.
    function showInquiryView() {
        if (!activeSlot || !panelViews) {
            return;
        }

        if (inquiryName) {
            inquiryName.textContent =
                activeSlot.getAttribute('data-floorplan-name') || '';
        }

        if (inquirySummary) {
            inquirySummary.innerHTML =
                (activeSlot.getAttribute('data-bedrooms') || '') +
                ' Bedroom / ' +
                (activeSlot.getAttribute('data-bathroom') || '') +
                ' Bathroom<br>' +
                (activeSlot.getAttribute('data-size') || '');
        }

        if (inquiryFloorplanField) {
            inquiryFloorplanField.value =
                activeSlot.getAttribute('data-floorplan-name') || '';
        }

        if (inquiryUnitField) {
            inquiryUnitField.value =
                activeSlot.getAttribute('data-unit-number') || '';
        }

        panelViews.classList.add('show-inquiry');
    }

    function showDetailView() {
        if (panelViews) {
            panelViews.classList.remove('show-inquiry');
        }
    }

    function closeSiteplanPanel() {
        if (siteplanInner) {
            siteplanInner.classList.remove('is-active');
        }

        siteplanSlots.forEach(function (slot) {
            slot.classList.remove('is-selected');
        });

        // Reset back to the detail sub-view so the next slot opened doesn't
        // start on whatever sub-view was last showing.
        showDetailView();
        activeSlot = null;
    }

    siteplanSlots.forEach(function (slot) {
        slot.addEventListener('click', function () {
            siteplanSlots.forEach(function (other) {
                other.classList.toggle('is-selected', other === slot);
            });

            activeSlot = slot;
            showDetailView();

            var color = slot.getAttribute('data-color') || '#3e93a1';

            if (panelBand) {
                panelBand.style.backgroundColor = color;
            }

            if (panelInquireBtn) {
                panelInquireBtn.style.setProperty('--accent-color', color);
            }

            if (panelViews) {
                panelViews.style.setProperty('--accent-color', color);
            }

            if (panelName) {
                panelName.textContent =
                    slot.getAttribute('data-floorplan-name') || '';
            }

            if (panelUnit) {
                panelUnit.textContent =
                    'Unit # ' + (slot.getAttribute('data-unit-number') || '—');
            }

            if (panelDetails) {
                // "Long Sqft" is the floorplan's multi-line Ground/Upper/
                // Basement/Total breakdown (see the ACF field of the same
                // name), not the short "Sqft" summary used on the
                // Floorplan View cards - matches single-floorplan.php's
                // own detail breakdown, "Total" line bolded the same way.
                var sqftLines = (slot.getAttribute('data-long-sqft') || '')
                    .split('\n')
                    .map(function (line) {
                        return line.trim();
                    })
                    .filter(function (line) {
                        return line !== '';
                    })
                    .map(function (line) {
                        return /^total/i.test(line)
                            ? '<strong>' + line + '</strong>'
                            : line;
                    });

                panelDetails.innerHTML =
                    (slot.getAttribute('data-bedrooms') || '') +
                    ' Bedroom / ' +
                    (slot.getAttribute('data-bathroom') || '') +
                    ' Bathroom<br>' +
                    sqftLines.join('<br>');
            }

            if (panelPrice) {
                panelPrice.textContent = formatSlotPrice(
                    slot.getAttribute('data-price')
                );
            }

            if (panelPdf) {
                var pageUrl = slot.getAttribute('data-page') || '';
                panelPdf.href = pageUrl;
                panelPdf.hidden = !pageUrl;
            }

            if (panelCarbon && panelCarbonImg) {
                var carbonUrl = slot.getAttribute('data-carbon') || '';
                panelCarbonImg.src = carbonUrl;
                panelCarbon.hidden = !carbonUrl;
            }

            if (siteplanInner) {
                siteplanInner.classList.add('is-active');
            }
        });
    });

    if (panelClose) {
        panelClose.addEventListener('click', closeSiteplanPanel);
    }

    if (panelInquireBtn) {
        panelInquireBtn.addEventListener('click', showInquiryView);
    }

    if (inquiryBackBtn) {
        inquiryBackBtn.addEventListener('click', showDetailView);
    }

    // Submits via AJAX (see parkfieldSubmitLead above) rather than a normal
    // page POST, so the open panel/slide state isn't lost on reload.
    var inquiryForm = availabilityPage.querySelector(
        '.availability-siteplan__inquiry-form'
    );
    var inquiryFormMessage = availabilityPage.querySelector(
        '.availability-siteplan__inquiry-message'
    );

    if (inquiryForm) {
        inquiryForm.addEventListener('submit', function (event) {
            event.preventDefault();
            parkfieldSubmitLead(
                inquiryForm,
                'availability_panel',
                inquiryFormMessage
            );
        });
    }

    // Legend: clicking a floorplan name isolates its slots on the map.
    // Clicking a second name adds it (any number of floorplans can be
    // isolated at once, not just one) rather than replacing the first;
    // clicking every isolated name back off returns to showing all slots.
    var legendList = availabilityPage.querySelector(
        '.availability-siteplan__legend-list'
    );
    var legendItems = Array.prototype.slice.call(
        availabilityPage.querySelectorAll('.availability-siteplan__legend-item')
    );
    var siteplanLabels = Array.prototype.slice.call(
        availabilityPage.querySelectorAll('.availability-siteplan__label')
    );
    var isolatedFloorplanIds = [];

    function applyLegendFilter() {
        var hasSelection = isolatedFloorplanIds.length > 0;

        if (legendList) {
            legendList.classList.toggle('has-selection', hasSelection);
        }

        legendItems.forEach(function (item) {
            item.classList.toggle(
                'is-active',
                isolatedFloorplanIds.indexOf(item.dataset.floorplanId) !== -1
            );
        });

        var selectedSlotNowHidden = false;

        siteplanSlots.forEach(function (slot) {
            var isFilteredOut =
                hasSelection &&
                isolatedFloorplanIds.indexOf(slot.dataset.floorplanId) === -1;
            slot.classList.toggle('is-filtered-out', isFilteredOut);

            if (isFilteredOut && slot.classList.contains('is-selected')) {
                selectedSlotNowHidden = true;
            }
        });

        siteplanLabels.forEach(function (label) {
            var isFilteredOut =
                hasSelection &&
                isolatedFloorplanIds.indexOf(label.dataset.floorplanId) === -1;
            label.classList.toggle('is-filtered-out', isFilteredOut);
        });

        // The detail panel is open for a slot that just got filtered out -
        // close it rather than leaving it showing a unit that's no longer
        // visible on the map.
        if (selectedSlotNowHidden) {
            closeSiteplanPanel();
        }
    }

    // Deep link from a floorplan's own page ("View on Siteplan" passes
    // ?fp=<id> alongside ?view=siteplan) - pre-isolate the legend to just
    // that floorplan, same as clicking its legend item, so the map opens
    // already filtered down to it instead of showing every unit. Not named
    // "floorplan" - that collides with WordPress's own public query var for
    // the floorplan CPT's rewrite rules and 404s the page (see the PHP side
    // in single-floorplan.php).
    var requestedFloorplanId = new URLSearchParams(window.location.search).get(
        'fp'
    );

    if (
        requestedFloorplanId &&
        legendItems.some(function (item) {
            return item.dataset.floorplanId === requestedFloorplanId;
        })
    ) {
        isolatedFloorplanIds.push(requestedFloorplanId);
        applyLegendFilter();
    }

    legendItems.forEach(function (item) {
        item.addEventListener('click', function () {
            var floorplanId = item.dataset.floorplanId;
            var index = isolatedFloorplanIds.indexOf(floorplanId);

            if (index === -1) {
                isolatedFloorplanIds.push(floorplanId);
            } else {
                isolatedFloorplanIds.splice(index, 1);
            }

            applyLegendFilter();
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // Single floorplan page: "Inquire Now" opens a standard centered modal
    // (not the Availability page's sliding side panel, since this page
    // isn't tied to a specific unit/slot) - see .floorplan-inquiry-modal in
    // _floorplan-single.scss.
    var inquireBtn = document.getElementById('floorplan-single-inquire-btn');
    var modal = document.getElementById('floorplan-inquiry-modal');

    if (inquireBtn && modal) {
        var modalClose = document.getElementById(
            'floorplan-inquiry-modal-close'
        );
        var modalBackdrop = document.getElementById(
            'floorplan-inquiry-modal-backdrop'
        );
        var modalForm = modal.querySelector('.floorplan-inquiry-modal__form');

        // .is-open drives a CSS opacity/visibility fade (see
        // .floorplan-inquiry-modal in _floorplan-single.scss) - the modal
        // stays in the DOM at all times rather than being toggled via the
        // hidden attribute, since [hidden]'s display:none can't be
        // transitioned.
        function openInquiryModal() {
            modal.classList.add('is-open');
        }

        function closeInquiryModal() {
            modal.classList.remove('is-open');
        }

        inquireBtn.addEventListener('click', openInquiryModal);

        if (modalClose) {
            modalClose.addEventListener('click', closeInquiryModal);
        }

        if (modalBackdrop) {
            modalBackdrop.addEventListener('click', closeInquiryModal);
        }

        document.addEventListener('keydown', function (event) {
            if ('Escape' === event.key && modal.classList.contains('is-open')) {
                closeInquiryModal();
            }
        });

        // Submits via AJAX (see parkfieldSubmitLead above) rather than a
        // normal page POST, same reasoning as the Availability page's panel
        // form - a reload here would also close the modal.
        var modalFormMessage = modal.querySelector(
            '.floorplan-inquiry-modal__message'
        );

        if (modalForm) {
            modalForm.addEventListener('submit', function (event) {
                event.preventDefault();
                parkfieldSubmitLead(
                    modalForm,
                    'floorplan_modal',
                    modalFormMessage
                );
            });
        }
    }

    // "Desired Move-In Date" on the Inquire Now page - see
    // .inquire-form__field--date in _inquire-page.scss and the flatpickr
    // registration in functions.php.
    if (window.flatpickr) {
        Array.prototype.slice
            .call(document.querySelectorAll('.js-datepicker'))
            .forEach(function (input) {
                window.flatpickr(input, {
                    dateFormat: 'F j, Y',
                    minDate: 'today',
                    disableMobile: true
                });
            });
    }

    // Floorplan diagram magnifying lens (single floorplan page). Circular
    // lens follows the cursor over the image, showing a zoomed-in crop of
    // whatever's under it via background-position - same technique
    // e-commerce product zoom uses, rather than a separate side-by-side
    // zoom panel. Desktop/mouse only - see the (hover: hover) media query
    // on &__diagram and the max-width: 768px cutoff on &__zoom-lens in
    // _floorplan-single.scss.
    var floorplanWrapper = document.querySelector('.floorplan-single');
    var diagram = floorplanWrapper
        ? floorplanWrapper.querySelector('.floorplan-single__diagram')
        : null;

    if (
        floorplanWrapper &&
        diagram &&
        window.matchMedia &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches
    ) {
        var ZOOM = 2.5;
        var lens = document.createElement('div');
        lens.className = 'floorplan-single__zoom-lens';
        lens.setAttribute('aria-hidden', 'true');
        floorplanWrapper.appendChild(lens);

        diagram.addEventListener('mouseenter', function () {
            lens.style.backgroundImage = 'url(' + diagram.currentSrc + ')';
            lens.classList.add('is-visible');
        });

        diagram.addEventListener('mousemove', function (event) {
            var rect = diagram.getBoundingClientRect();
            var lensRadius = lens.offsetWidth / 2;
            var x = event.clientX - rect.left;
            var y = event.clientY - rect.top;

            lens.style.left = event.clientX - lensRadius + 'px';
            lens.style.top = event.clientY - lensRadius + 'px';
            lens.style.backgroundSize =
                rect.width * ZOOM + 'px ' + rect.height * ZOOM + 'px';
            lens.style.backgroundPosition =
                -(x * ZOOM - lensRadius) +
                'px ' +
                -(y * ZOOM - lensRadius) +
                'px';
        });

        diagram.addEventListener('mouseleave', function () {
            lens.classList.remove('is-visible');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // "Whole Community" gallery image (Home page's .home-community__gallery
    // and Community page's .community-story__gallery, both marked
    // .js-scroll-rail) - the img is wider than its overflow:hidden wrapper,
    // leaving extra width parked just off the right edge of the viewport.
    // As the wrapper scrolls through view, pan the img left to reveal a bit
    // of that reserved space - an "on rails" scroll-tied movement rather
    // than a fixed-duration animation.
    var railWrappers = Array.prototype.slice.call(
        document.querySelectorAll('.js-scroll-rail')
    );

    if (!railWrappers.length) {
        return;
    }

    // Expressed in rem (like the rest of this theme's sizing) and resolved
    // against the root font-size at update time, since html { font-size }
    // is fluid/viewport-based rather than a fixed 16px - see _child_theme.scss.
    var MAX_SHIFT_REM = 5;
    var ticking = false;

    function updateRails() {
        ticking = false;

        var viewportHeight = window.innerHeight;
        var maxShiftPx =
            MAX_SHIFT_REM *
            parseFloat(getComputedStyle(document.documentElement).fontSize);

        railWrappers.forEach(function (wrapper) {
            var img = wrapper.querySelector('img');

            if (!img) {
                return;
            }

            var rect = wrapper.getBoundingClientRect();

            // Outside the viewport (above or below) - leave it at rest
            // instead of continuing to move it while offscreen.
            if (rect.bottom < 0 || rect.top > viewportHeight) {
                return;
            }

            // 0 as the wrapper's top just enters the bottom of the
            // viewport, 1 as its bottom just leaves the top - ties the pan
            // directly to scroll position rather than time.
            var progress =
                (viewportHeight - rect.top) / (viewportHeight + rect.height);
            progress = Math.min(1, Math.max(0, progress));

            img.style.transform =
                'translateX(-' + progress * maxShiftPx + 'px)';
        });
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(updateRails);
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateRails();
});
